(function () {
  'use strict';

  var input = document.querySelector('[data-pwr-dealer-search]');
  var button = document.querySelector('[data-pwr-dealer-search-btn]');
  var resultsWrap = document.querySelector('[data-pwr-dealer-results]');
  var emptyState = document.querySelector('[data-pwr-dealer-empty]');
  var countEl = document.querySelector('[data-pwr-dealer-count]');
  if (!resultsWrap || !countEl) return;

  var cards = Array.prototype.slice.call(resultsWrap.querySelectorAll('[data-pwr-dealer-card]'));
  var totalDealers = cards.length;

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function runFilter() {
    var query = normalize(input ? input.value : '');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var haystack = [
        card.getAttribute('data-name'),
        card.getAttribute('data-city'),
        card.getAttribute('data-state'),
        card.getAttribute('data-pincode')
      ].map(normalize).join(' ');

      var matches = query === '' || haystack.indexOf(query) !== -1;
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (totalDealers === 0) {
      countEl.textContent = '';
      resultsWrap.hidden = true;
      if (emptyState) emptyState.hidden = false;
    } else if (visibleCount === 0) {
      countEl.textContent = '0 dealers found';
      resultsWrap.hidden = true;
      if (emptyState) emptyState.hidden = false;
    } else {
      countEl.textContent = visibleCount + (visibleCount === 1 ? ' dealer found' : ' dealers found');
      resultsWrap.hidden = false;
      if (emptyState) emptyState.hidden = true;
    }
  }

  if (input) {
    input.addEventListener('input', runFilter);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        runFilter();
      }
    });
  }

  if (button) {
    button.addEventListener('click', runFilter);
  }

  runFilter();
})();
